import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { injectIntl } from "react-intl"
import { Redirect } from "react-router-dom"
import SideBar from "../common/layout/sidebar.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"

const SubscriptionListing = () => {
    SideBar.activateMenu("subscription")

    if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
        return <Redirect to={{ pathname: "/" }} />
    }

    return (
        <div>
            <GenericListing
                objectType={ObjectType.SUBSCRIPTIONS}
            />
        </div>
    )
}

export default injectIntl(SubscriptionListing)



// WEBPACK FOOTER //
// ./src/invoice/SubscriptionsList.tsx